const initializeDesktopMenu = () => {
  console.log("Desktop menu initialized"); 
  const secondTriggers = document.querySelectorAll("[data-second-level]");
  const allSecondMenus = document.querySelectorAll(".second-level-menu");
  const thirdTriggers = document.querySelectorAll("[data-third-level]");
  const allThirdMenus = document.querySelectorAll(".third-level-menu");
  const firstLevelDiv = document.querySelector('#first-level-col');
  const secondLevelDiv = document.querySelector('#second-level-col');
  const thirdLevelDiv = document.querySelector('#third-level-col');

  let selectedFirst = null;
  let selectedSecond = null;
  let selectedThird = null;

 
  secondTriggers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log(`Clicked First Level: ${btn.getAttribute('data-second-level')}`); 

      const targetID = btn.getAttribute('data-second-level');
      const targetMenu = document.getElementById('second-' + targetID);

     
      allSecondMenus.forEach((menu) => menu.classList.add('hidden'));
      allThirdMenus.forEach((menu) => menu.classList.add('hidden'));
      secondLevelDiv.classList.remove('border-active');
      thirdLevelDiv.classList.remove('border-active');

   
  
   if (selectedFirst) {
    selectedFirst.classList.remove('selected');
  }
  btn.classList.add('selected');
  selectedFirst = btn;

     
      if (targetMenu) {
        targetMenu.classList.remove('hidden');
        secondLevelDiv.classList.add('border-active');
      }
    });
  });

 
  thirdTriggers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log(`Clicked Second Level: ${btn.getAttribute('data-third-level')}`); // Debugging

      const targetID = btn.getAttribute('data-third-level');
      const targetMenu = document.getElementById('third-' + targetID);

   
      allThirdMenus.forEach((menu) => menu.classList.add('hidden'));
      thirdLevelDiv.classList.remove('border-active');

      
      if (selectedSecond) {
        selectedSecond.classList.remove('selected');
      }
      btn.classList.add('selected');
      selectedSecond = btn;

      if (targetMenu) {
        targetMenu.classList.remove('hidden');
        thirdLevelDiv.classList.add('border-active');
      } 
    });
  });

  
  document.querySelectorAll('#third-level-col a').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      if (selectedThird) {
        selectedThird.classList.remove('selected');
      }
      btn.classList.add('selected');
      selectedThird = btn;
    });
  });
};


window.addEventListener('DOMContentLoaded', () => {
  initializeDesktopMenu();
});

